import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/LanguageProvider';

const FooterNav = ({
  className,
  ...props
}) => {
  const { t } = useTranslation();

  const classes = classNames(
    'footer-nav',
    className
  );

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="/contact" onClick={scrollToTop}>{t('navigation.contact')}</Link>
        </li>
        <li>
          <Link to="/about" onClick={scrollToTop}>{t('navigation.about')}</Link>
        </li>
        <li>
          <Link to="/blog" onClick={scrollToTop}>{t('navigation.blog')}</Link>
        </li>
        <li>
          <Link to="/careers" onClick={scrollToTop}>{t('navigation.careers')}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
